import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { FormHelperService } from 'src/app/core/helpers/form-helper/form-helper.service';
import { Equipment, EquipmentCategory } from 'src/app/core/models/equipment-category.model';
import { InventoryStatus, TruckInventoryFilters, TruckInventoryIdCode } from 'src/app/core/models/inventory.model';
import { EquipmentService } from 'src/app/core/services/equipment/equipment.service';
import { InventoryService } from 'src/app/core/services/inventory/inventory.service';

@Component({
	selector: 'app-truck-inventory-filter',
	templateUrl: './truck-inventory-filter.component.html',
	styleUrls: ['./truck-inventory-filter.component.scss'],
})
export class TruckInventoryFilterComponent implements OnInit {

	@Input()
	lastFilters: TruckInventoryFilters;

	pageTitle = 'Inventory Filter';

	form: FormGroup;
	statusOptions = [] as InventoryStatus[];
	defaultStatusOption: InventoryStatus;
	categoryOptions = [] as EquipmentCategory[];
	defaultCategoryOption: EquipmentCategory;
	equipmentOptions = [] as Equipment[];
	defaultEquipmentOption = { id: 0, name: 'All', attributeIds: [-1] } as Equipment;

	constructor(
		private modalController: ModalController,
		private formBuilder: FormBuilder,
		public formHelper: FormHelperService,
		private inventoryService: InventoryService,
		private equipmentService: EquipmentService,
	) { }

	async ngOnInit(): Promise<void> {
		await this.initOptions();

		this.form = this.formBuilder.group({
			status: [this.defaultStatusOption, Validators.required],
			category: [this.defaultCategoryOption, Validators.required],
			equipment: [this.defaultEquipmentOption, Validators.required],
		});

		const { statusId, categoryId, equipmentId } = this.lastFilters;
		if (statusId) {
			this.form.controls.status.setValue(this.statusOptions.find(so => so.id === statusId));
		}

		if (categoryId) {
			const category = this.categoryOptions.find(ca => ca.id === categoryId);
			this.form.controls.category.setValue(category);
			this.equipmentOptions = category.equipment;
		}

		if (equipmentId) {
			this.form.controls.equipment.setValue(this.form.controls.category.value.equipment.find(e => e.id === equipmentId));
		}
	}

	async initOptions(): Promise<void> {
		this.statusOptions = await this.inventoryService.getAllInventoryStatuses();
		this.defaultStatusOption = this.statusOptions.find(so => so.id === TruckInventoryIdCode.AVAILABLE);

		this.categoryOptions = await this.equipmentService.getCategories();
		this.defaultCategoryOption = { id: 0, name: '', equipment: [] };

		this.equipmentOptions = this.defaultCategoryOption.equipment;
	}

	onChangeCategory(category: EquipmentCategory): void {
		this.form.controls.equipment.setValue(this.defaultEquipmentOption);
		this.equipmentOptions = category.equipment;
	}

	async onClickApplyFilter() {
		await this.dismiss();
	}

	getFilters() {
		return {
			statusId: this.form.value.status.id ?? 0,
			categoryId: this.form.value.category.id,
			equipmentId: this.form.value.equipment.id,
		};
	}

	async dismiss(): Promise<void> {
		await this.modalController.dismiss({
			dismissed: true,
			filters: this.getFilters(),
		});
	}
}
